module.exports = __webpack_public_path__ + "img/CM-BS-25-CJDR-Established.cd0cf882.jpg";